import * as fromDatatype from '../datatype-library/index';

export interface bl_mrp_pi_worklog_historical_Rowinterface {
  guid: fromDatatype.GuidDataFieldInterface;
  worklog_guid: fromDatatype.GuidDataFieldInterface;
  machine_guid_new: fromDatatype.GuidDataFieldInterface;
  machine_guid_old: fromDatatype.GuidDataFieldInterface;
  process_instance_hdr_guid_new: fromDatatype.GuidDataFieldInterface;
  process_instance_hdr_guid_old: fromDatatype.GuidDataFieldInterface;
  job_order_hdr_guid_new: fromDatatype.GuidDataFieldInterface;
  job_order_hdr_guid_old: fromDatatype.GuidDataFieldInterface;
  fi_item_guid_new: fromDatatype.GuidDataFieldInterface;
  fi_item_guid_old: fromDatatype.GuidDataFieldInterface;
  namespace_new: fromDatatype.VarcharDatatypeInterface;
  namespace_old: fromDatatype.VarcharDatatypeInterface;
  approval_status_new: fromDatatype.VarcharDatatypeInterface;
  approval_status_old: fromDatatype.VarcharDatatypeInterface;
  priority_new: fromDatatype.NumericDatatypeInterface;
  priority_old: fromDatatype.NumericDatatypeInterface;
  qc_input_status_new: fromDatatype.VarcharDatatypeInterface;
  qc_input_status_old: fromDatatype.VarcharDatatypeInterface;
  shift_date_new: fromDatatype.TimestampTzDatatypeInterface;
  shift_date_old: fromDatatype.TimestampTzDatatypeInterface;
  shift_remarks_new: fromDatatype.VarcharDatatypeInterface;
  shift_remarks_old: fromDatatype.VarcharDatatypeInterface;
  shift_type_new: fromDatatype.VarcharDatatypeInterface;
  shift_type_old: fromDatatype.VarcharDatatypeInterface;
  start_time_new: fromDatatype.TimestampTzDatatypeInterface;
  start_time_old: fromDatatype.TimestampTzDatatypeInterface;
  end_time_new: fromDatatype.TimestampTzDatatypeInterface;
  end_time_old: fromDatatype.TimestampTzDatatypeInterface;
  total_time_new: fromDatatype.NumericDatatypeInterface;
  total_time_old: fromDatatype.NumericDatatypeInterface;
  qty_produced_new: fromDatatype.NumericDatatypeInterface;
  qty_produced_old: fromDatatype.NumericDatatypeInterface;
  total_qty_required_new: fromDatatype.NumericDatatypeInterface;
  total_qty_required_old: fromDatatype.NumericDatatypeInterface;
  total_qty_produced_new: fromDatatype.NumericDatatypeInterface;
  total_qty_produced_old: fromDatatype.NumericDatatypeInterface;
  production_rate_new: fromDatatype.NumericDatatypeInterface;
  production_rate_old: fromDatatype.NumericDatatypeInterface;
  production_rate_material_uom_new: fromDatatype.VarcharDatatypeInterface;
  production_rate_material_uom_old: fromDatatype.VarcharDatatypeInterface;
  production_rate_time_uom_new: fromDatatype.VarcharDatatypeInterface;
  production_rate_time_uom_old: fromDatatype.VarcharDatatypeInterface;
  uom_new: fromDatatype.VarcharDatatypeInterface;
  uom_old: fromDatatype.VarcharDatatypeInterface;
  custom_attribute_json_new: any;
  custom_attribute_json_old: any;
  custom_quantifiable_attribute_json_old: any;
  custom_quantifiable_attribute_json_new: any;
  property_json_new: any;
  property_json_old: any;
  status_new: fromDatatype.VarcharDatatypeInterface;
  status_old: fromDatatype.VarcharDatatypeInterface;
  revision_new: fromDatatype.GuidDataFieldInterface;
  revision_old: fromDatatype.GuidDataFieldInterface;
  vrsn_new: fromDatatype.VarcharDatatypeInterface;
  vrsn_old: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid_new: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid_old: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid_new: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid_old: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  module_guid_new: fromDatatype.GuidDataFieldInterface;
  module_guid_old: fromDatatype.GuidDataFieldInterface;
  applet_guid_new: fromDatatype.GuidDataFieldInterface;
  applet_guid_old: fromDatatype.GuidDataFieldInterface;
  acl_config_new: any;
  acl_config_old: any;
  acl_policy_new: any;
  acl_policy_old: any;
}

export class bl_mrp_pi_worklog_historical_Rowclass
  implements bl_mrp_pi_worklog_historical_Rowinterface {
  guid: fromDatatype.GuidDataFieldInterface;
  worklog_guid: fromDatatype.GuidDataFieldInterface;
  machine_guid_new: fromDatatype.GuidDataFieldInterface;
  machine_guid_old: fromDatatype.GuidDataFieldInterface;
  process_instance_hdr_guid_new: fromDatatype.GuidDataFieldInterface;
  process_instance_hdr_guid_old: fromDatatype.GuidDataFieldInterface;
  job_order_hdr_guid_new: fromDatatype.GuidDataFieldInterface;
  job_order_hdr_guid_old: fromDatatype.GuidDataFieldInterface;
  fi_item_guid_new: fromDatatype.GuidDataFieldInterface;
  fi_item_guid_old: fromDatatype.GuidDataFieldInterface;
  namespace_new: fromDatatype.VarcharDatatypeInterface;
  namespace_old: fromDatatype.VarcharDatatypeInterface;
  approval_status_new: fromDatatype.VarcharDatatypeInterface;
  approval_status_old: fromDatatype.VarcharDatatypeInterface;
  priority_new: fromDatatype.NumericDatatypeInterface;
  priority_old: fromDatatype.NumericDatatypeInterface;
  qc_input_status_new: fromDatatype.VarcharDatatypeInterface;
  qc_input_status_old: fromDatatype.VarcharDatatypeInterface;
  shift_date_new: fromDatatype.TimestampTzDatatypeInterface;
  shift_date_old: fromDatatype.TimestampTzDatatypeInterface;
  shift_remarks_new: fromDatatype.VarcharDatatypeInterface;
  shift_remarks_old: fromDatatype.VarcharDatatypeInterface;
  shift_type_new: fromDatatype.VarcharDatatypeInterface;
  shift_type_old: fromDatatype.VarcharDatatypeInterface;
  start_time_new: fromDatatype.TimestampTzDatatypeInterface;
  start_time_old: fromDatatype.TimestampTzDatatypeInterface;
  end_time_new: fromDatatype.TimestampTzDatatypeInterface;
  end_time_old: fromDatatype.TimestampTzDatatypeInterface;
  total_time_new: fromDatatype.NumericDatatypeInterface;
  total_time_old: fromDatatype.NumericDatatypeInterface;
  qty_produced_new: fromDatatype.NumericDatatypeInterface;
  qty_produced_old: fromDatatype.NumericDatatypeInterface;
  total_qty_required_new: fromDatatype.NumericDatatypeInterface;
  total_qty_required_old: fromDatatype.NumericDatatypeInterface;
  total_qty_produced_new: fromDatatype.NumericDatatypeInterface;
  total_qty_produced_old: fromDatatype.NumericDatatypeInterface;
  production_rate_new: fromDatatype.NumericDatatypeInterface;
  production_rate_old: fromDatatype.NumericDatatypeInterface;
  production_rate_material_uom_new: fromDatatype.VarcharDatatypeInterface;
  production_rate_material_uom_old: fromDatatype.VarcharDatatypeInterface;
  production_rate_time_uom_new: fromDatatype.VarcharDatatypeInterface;
  production_rate_time_uom_old: fromDatatype.VarcharDatatypeInterface;
  uom_new: fromDatatype.VarcharDatatypeInterface;
  uom_old: fromDatatype.VarcharDatatypeInterface;
  custom_attribute_json_new: any;
  custom_attribute_json_old: any;
  custom_quantifiable_attribute_json_old: any;
  custom_quantifiable_attribute_json_new: any;
  property_json_new: any;
  property_json_old: any;
  status_new: fromDatatype.VarcharDatatypeInterface;
  status_old: fromDatatype.VarcharDatatypeInterface;
  revision_new: fromDatatype.GuidDataFieldInterface;
  revision_old: fromDatatype.GuidDataFieldInterface;
  vrsn_new: fromDatatype.VarcharDatatypeInterface;
  vrsn_old: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid_new: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid_old: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid_new: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid_old: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  module_guid_new: fromDatatype.GuidDataFieldInterface;
  module_guid_old: fromDatatype.GuidDataFieldInterface;
  applet_guid_new: fromDatatype.GuidDataFieldInterface;
  applet_guid_old: fromDatatype.GuidDataFieldInterface;
  acl_config_new: any;
  acl_config_old: any;
  acl_policy_new: any;
  acl_policy_old: any;
}